<template>
  <section class="mainText ">
    <b-container fluid="xl">
        <b-row class="maintText__row">
        <b-col cols="12" class="mainText__mainName side-gap">

          <h2 style="mainText__mainName--maintxtx">
            Posztolnád az élményeidet nyaralás alatt? 
          </h2>
          <p class="hashText">- Adunk pár tippet a biztonságodért</p>
        </b-col>
      </b-row>
        <b-row class="maintText__row">
            <b-col cols="12" lg="6">
            <div class="maintText__txt-content pb-lg-5 pb-2">
                <p class="text">
                Ahogy a nyári szünet közeledik, sokan tervezik már nyaralásukat, azonban, amikor elutazunk és élvezzük a szabadidőt és ezt legszívesebben világgá kürtölnénk, fontos átgondolnunk, hogy mit és hogyan osztunk meg a közösségi médiában. Összeállítottunk egy listát arról, miket érdemes megfontolni, mielőtt lenyomnád azt a bizonyos megosztás gombot. </p>

            </div>
            </b-col>
            <b-col cols="12" lg="6" class="order-4 order-lg-1">
              <img src="images/elmenyek.png" class="w-100 margin-top-sm-44 mb-4"/>
          </b-col>
            <b-col cols="12" lg="10" class="offset-lg-1 side-gap order-lg-2 order-1">
            <p class="text">
              <ul>
                <li class="py-3 d-sm-flex">
                  <span class="number">1</span>
                  <p class="text"><b>Ne posztolj azonnal!</b> Bár érthető, hogy izgatott vagy a nyaralásod miatt, ne oszd meg az információt azonnal. Azazonnali posztolás azt jelenti, hogy a nyaralás helyszíne és időpontja nyilvánosságra kerül, és ez lehetőséget ad a betörőknek arra, hogy kihasználják, hogy a lakásod vagy a házad felügyelet nélkül van. Várj, amíg visszatérsz a nyaralásról, mielőtt megosztod az élményeidet!</p> 
                </li>
                <li class="py-3 d-sm-flex">
                  <span class="number">2</span>
                  <p class="text"><b>Vigyázz a helyszín megosztásával!</b>Ha úgy döntesz, hogy posztolsz a nyaralásodról, kerüld el az olyan információk megosztását, amelyek egyértelműen a konkrét helyszínedet jelölik. Például ne említsd meg pontosan, hol vagy éppen, vagy ne oszd meg azonnal a GPS-koordinátákat vagy jelöld be az aktuális helyszínedet. Ez védelmet nyújt az illetéktelenek számára, hogy követhessék az utadat vagy kihasználhassák a távollétedet.</p>
                </li>
                <li class="py-3 d-sm-flex">
                  <span class="number">3</span>
                  <p class="text"><b>Kerüld az értéktárgyak bemutatását! </b> Bár izgalmas lehet megosztani az új nyaralási felszerelésed vagy drága tárgyaidat, például a laptopodat vagy az új ékszereidet, ez vonzza a tolvajok figyelmét. Inkább koncentrálj a hely természetes szépségeire és az élményeidre, mintsem az értékes tárgyakra!</p>
                </li>
                <li class="py-3 d-sm-flex">
                  <span class="number">4</span>
                  <p class="text"><b>Használj láthatósági beállításokat!</b> A közösségi média platformok általában kínálnak beállítási lehetőségeket a tartalmak magánszférájának védelmére. Használd ezeket a funkciókat, hogy korlátozd a posztjaid láthatóságát! Például beállíthatod, hogy csak a barátaid láthassák a bejegyzéseidet, vagy létrehozhatsz egy kis zárt csoportot, amelynek csak a megbízható ismerőseid lehetnek tagjai.</p>
                </li>
                <li class="py-3 d-sm-flex">
                  <span class="number">5</span>
                  <p class="text"><b>Ügyelj mások személyiségi jogaira! </b> Nyaralás alatt minden viccesnek, szórakoztatónak tűnhet, akár egy rosszul elkapott kép, vagy egy kínos sztori megörökítése is. Nagyon fontos azonban átgondolni, mit posztolsz, mert az internetre feltöltve nem tudod nyomon követni, ki látja, hova kerülhet a megosztott tartalmad. Legyen szó egy átbulizott éjszakáról, egy előnytelen képről vagy egy kiszolgáltatott helyzetben lévő barát posztolásáról, vedd figyelembe, hogy éreznéd magad, ha rólad tennének ki ilyen képet, illetve hogy beleegyezett-e a tartalom megosztásába a képen, vagy videón (jól beazonosíthatóan) látható összes ember. Ha mégis a posztolás mellett döntenél, mindig ott van opcióként az, hogy kivágod a képről azokat, akik nem szeretnének rajta szerepelni. </p>
                </li>
                <li class="py-3 d-sm-flex">
                  <span class="number">5</span>
                  <p class="text"><b>Óvatosan a fürdőruhás képekkel. </b> Ha a személyiségi jogokról beszélünk, különösen oda kell figyelnünk, milyen képeket osztunk meg másokról lengébb öltözetben: főként, ha gyerekekről van szó. A nagy melegben természetes, ha megszabadulunk pár rétegtől, ám ezek a képek könnyen kerülhetnek illetéktelenek kezébe, így saját képeink esetében is érdemes feltenni a kérdést: szeretnénk, ha minden egyes ismerősünk, beleértve a távoli rokonokat, kollégákat vagy akár a főnököt, így látna minket?  </p>
                </li>
              </ul>
            </p>
            <p class="text">Reméljük, ezek a tippek segítenek abban, hogy okosan posztolj a nyaralás alatt, és minimalizáld a potenciális kockázatokat. Emlékezz, hogy az elsődleges cél a pihenés és az élmények élvezete, ezért inkább élvezd a pillanatot, és oszd meg az emlékeidet akkor, amikor már biztonságosan visszatértél a nyaralásról, és kellőképp át tudod gondolni, mit szeretnél posztolni és mit nem a közösségi médiára! </p>
        </b-col>
        </b-row>
    </b-container>
    <Articles :isFirst="false"/>
  </section>
</template>
<script>
import Articles from '../components/Articles.vue'

export default {
  components: {
    Articles
  },
  mounted(){

    this.setMetaTags({        
        title: "Posztolnád az élményeidet nyaralás alatt?", 
        desc: "Ahogy a nyári szünet közeledik, sokan tervezik már nyaralásukat, azonban, amikor elutazunk és élvezzük a szabadidőt és ezt legszívesebben világgá kürtölnénk, fontos átgondolnunk, hogy mit és hogyan osztunk meg a közösségi médiában.", 
        keywords: null, 
        ogType: 'website', 
        ogTitle: "Posztolnád az élményeidet nyaralás alatt?",
        ogImage: null, 
        ogImageWidth: null, 
        ogImageHeight: null, 
        ogDesc: "Ahogy a nyári szünet közeledik, sokan tervezik már nyaralásukat, azonban, amikor elutazunk és élvezzük a szabadidőt és ezt legszívesebben világgá kürtölnénk, fontos átgondolnunk, hogy mit és hogyan osztunk meg a közösségi médiában."        
    })
  }
}
</script>